// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"private-app-detail_clearfix_1gIS5"};